export * from './useCommonFieldsStructure';

export * from './useDependentsFieldsStructure';

export * from './useDomesticWorkerFieldsStructure';

export * from './usePrincipalFieldsStructure';
